import { render } from "./AddEditProjectModal.vue?vue&type=template&id=3f21a9e6&scoped=true"
import script from "./AddEditProjectModal.vue?vue&type=script&lang=js"
export * from "./AddEditProjectModal.vue?vue&type=script&lang=js"

import "./AddEditProjectModal.vue?vue&type=style&index=0&id=3f21a9e6&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-3f21a9e6"

export default script